(() => {
  const mount = scope => scope.querySelectorAll('.rf-detail').forEach(root => {
    const gallery = root.querySelector('media-gallery'), counter = root.querySelector('[data-rf-detail-counter]');
    if (!gallery || !counter || gallery.dataset.rfCounter) return;
    gallery.dataset.rfCounter = 'true';
    const update = () => {
      const slides = [...gallery.querySelectorAll('.product__media-list > [data-media-id]')];
      const selected = gallery.querySelector('.thumbnail[aria-current]')?.closest('[data-media-position]');
      const current = selected ? Number(selected.dataset.mediaPosition)-1 : slides.findIndex(slide => slide.classList.contains('is-active'));
      counter.textContent = String(Math.max(0,current)+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');
    };
    const observer = new MutationObserver(update);
    observer.observe(gallery,{subtree:true,attributes:true,attributeFilter:['class','aria-current'],childList:true});
    update();
    root.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});
  });
  mount(document); document.addEventListener('shopify:section:load',e=>mount(e.target));
})();
